import { useEffect } from "react";
import { queryClient } from "../../../App";
import { HttpClientError } from "../../../providers/HttpClient";
import useDownloadEmployeeImportJobResultFileApiService from "../services/api/DownloadEmployeeImportJobResultFileApiService";
import { useToasts } from "../../../providers/notifications/ToastsContext";

export default function DownloadResultsFileImportJobHook(): {
  downloadResultsFile: (id: number) => void;
} {
  const {
    isSuccess,
    isError,
    mutate,
    data: downloadResultFileResponse,
    error,
  } = useDownloadEmployeeImportJobResultFileApiService();
  const { showToast } = useToasts();

  const downloadResultsFile = (id: number): void => {
    mutate(id);
  };

  useEffect(() => {
    if (isError) {
      showToast({
        strapiId: "employee_data_import_file_dowload_failed",
        data: { message: HttpClientError(error) },
      });
    }
  }, [isError, error]);

  useEffect(() => {
    if (isSuccess) {
      window.location.assign(downloadResultFileResponse.file_url);
      showToast({ strapiId: "employee_data_import_result_file_downloaded" });
      queryClient.invalidateQueries(["EmployeeImportJobListApiService"]).then();
    }
  }, [isSuccess]);

  return {
    downloadResultsFile,
  };
}
